export default "__VITE_PUBLIC_ASSET__d300d1e1__"